<template>
  <div class="svg-container">
    <div class="moon">
      <img src="@/assets/images/bg/moon.svg" class="moon-img">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Moon'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .svg-container {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .moon {
    position: absolute;
    right: 15vw;
    width: 18vw;
    bottom: 31vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/Background/Moon.vue